// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1GjPL","title":"AfterBackImages_title__1I-yU","images":"AfterBackImages_images__nNNtW"};